let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');

let idMenuCollapsible = '#menu-collapsible';

class MenuCollapsible {

  constructor() {

    let $menu = $(idMenuCollapsible);
    let $trigger = $('#menu-collapsible-trigger');

    $trigger.on('click', () => {
      if(breakpoints.current === 'small' || breakpoints.current === 'medium') {
        $menu.toggleClass('menu-collapsible__open');
      }
    });

  }

}

function init() {
  if($(idMenuCollapsible).length) {
    let menuCollapsible = new MenuCollapsible();
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function (context, settings) {
      init();
    }
  };

}
